import { render, staticRenderFns } from "./LectureLessonResources.vue?vue&type=template&id=66cae35b&"
import script from "./LectureLessonResources.vue?vue&type=script&lang=js&"
export * from "./LectureLessonResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports